import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { withRouter } from "react-router";

const Fecha = (props) => {
  return (
    <Form.Group>
      <Row>
        <Form.Group as={Col} className="mb-3" sm="12" md="6" lg="6" xl="6">
          <Row>
            <Col xs="10" sm="10" md="10" lg="10" xl="10">
              <Form.Control
                name="fecha"
                className="rounded-pill"
                required
                type="text"
                disabled
                pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                placeholder="Año/Mes/Día   HH:MM"
              ></Form.Control>
            </Col>
            <Col xs="1" sm="1" md="1" lg="1" xl="1">
              <Button
                variant="light"
                size="sm"
                className="rounded-circle"
                // onClick={() => addArea()}
                disabled
              >
                <i className="material-icons">event</i>
              </Button>
            </Col>
          </Row>
        </Form.Group>
      </Row>
    </Form.Group>
  );
};

export default withRouter(Fecha);
